import React, { useContext } from "react"

import { useParams } from "react-router-dom"

import AudioRoom from "components/Pages/Teacher/AudioRooms/RoomEntry"

import TeacherContext from "../TeacherContext"

const TeacherAudioRoomPage = () => {
  const { audioRoomId } = useParams<{ audioRoomId: string }>()
  const viewer = useContext(TeacherContext)

  return <AudioRoom audioRoomId={audioRoomId} currentUserId={viewer.id} />
}

export default TeacherAudioRoomPage
